

export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/deleteExamSchool`,
                method: 'POST',
                body: payload
            };
        },
        invalidatesTags: ['allExamSchools']

    })
